require('./_set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** C:/dev/www/Iteca/SitoWeb/~/core-js/modules/es6.array.species.js
 ** module id = 164
 ** module chunks = 0
 **/